import { CSSProperties, useEffect, useState } from 'react';

import { Banner } from '@creditornot/alchemy-react';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { parseError } from 'common/utils/errorUtils';

type Props = {
  className?: string;
  error: Error | null;
  style?: CSSProperties;
};

export function ApiErrorBanner({ className, error, style }: Props) {
  const f = useFormatMessage();

  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    async function getParsedError() {
      try {
        const parsedError = error ? await parseError(error) : null;
        setMessage(parsedError);
      } catch {
        setMessage(f('common.unknown_error'));
      }
    }

    getParsedError();
  }, [error, f]);

  if (!message) {
    return null;
  }

  return (
    <Banner className={className} style={style} title={f('common.error')} variant="negative">
      {message}
    </Banner>
  );
}
